import Directory from "../../Components/Directory/Directory";
import "./HomePage.scss";

const HomePage = () => (
  <div className="homepage">
    <Directory />
  </div>
);

export default HomePage;
